var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExperimentsicon = function SvgExperimentsicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 2a1 1 0 0 1 0 2v4.824l3.939 10.833c.086.208.134.43.134.657a1.7 1.7 0 0 1-1.392 1.67A1 1 0 0 1 17.5 22h-11q-.091 0-.182-.017a1.7 1.7 0 0 1-1.256-2.326L9 8.824V4a1 1 0 0 1 0-2zM7.063 20h9.874L13.3 10h-2.6zM11 8h2V4h-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.063 20h9.874L13.3 10h-2.6z"
  })));
};
export default SvgExperimentsicon;